import { NO_ELEMENT } from 'utils';
import styles from './styles.scss';
import cn from 'classnames';

export interface TacticalFlagProps {
  tacticalFlagMarking?: string | null;
  tacticalFlagColor?: string | null;
}

interface TacticalFlagPropsAll extends TacticalFlagProps {
  className?: string;
  appearance?: 'small' | 'large';
}

export const TacticalFlag = ({
  tacticalFlagMarking,
  tacticalFlagColor,
  className,
  appearance
}: TacticalFlagPropsAll) => {
  if (!tacticalFlagMarking || !tacticalFlagColor) {
    return NO_ELEMENT;
  }

  return (
    <div
      className={cn(styles.tag, className, appearance && styles[appearance])}
      style={{ backgroundColor: `#${tacticalFlagColor}` }}
    >
      <p>{tacticalFlagMarking}</p>
    </div>
  );
};
